module.exports = __webpack_public_path__ + "images/fsoel_vermoegensdepot_result_2.svg?4fd6c92fe6a6724797be00c2bc3fff05";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fsoel_vermoegensdepot_result_2.svg
// module id = 1lyz
// module chunks = 0